// @dynamic

export class AOString {

  static onlyNumbers(text): string {
    return text.toString().replace(/\D/g, '');
  }

  static trim(text): string {
    return text.toString().replace(/\s+/g, ' ').trim();
  }

  static readingTime(text: string) {
    return text.length * 0.2 * 1000;
  }

  static slug(text): string {
    return text.toString().toLowerCase()
      .replace(/[Ã ÃÃ¡ÃÃ¢ÃÃ£Ã¤ÃÃÃ¥Âª]+/g, 'a')   // Special Characters #1
      .replace(/[Ã¨ÃÃ©ÃÃªÃÃ«Ã]+/g, 'e')       // Special Characters #2
      .replace(/[Ã¬ÃÃ­ÃÃ®ÃÃ¯Ã]+/g, 'i')       // Special Characters #3
      .replace(/[Ã²ÃÃ³ÃÃ´ÃÃµÃÃ¶ÃÂº]+/g, 'o')    // Special Characters #4
      .replace(/[Ã¹ÃÃºÃÃ»ÃÃ¼Ã]+/g, 'u')       // Special Characters #5
      .replace(/[Ã½ÃÃ¿Å¸]+/g, 'y')       		// Special Characters #6
      .replace(/[Ã±Ã]+/g, 'n')       			// Special Characters #7
      .replace(/[Ã§Ã]+/g, 'c')       			// Special Characters #8
      .replace(/[Ã]+/g, 'ss')       			// Special Characters #9
      .replace(/[ÃÃ¦]+/g, 'ae')       			// Special Characters #10
      .replace(/[ÃÃ¸Å]+/g, 'oe')       		// Special Characters #11
      .replace(/[%]+/g, 'pct')       			// Special Characters #12
      .replace(/\s+/g, '-')           		// Replace spaces with -
      .replace(/[^\w\-]+/g, '')       		// Remove all non-word chars
      .replace(/\-\-+/g, '-')         		// Replace multiple - with single -
      .replace(/^-+/, '')             		// Trim - from start of text
      .replace(/-+$/, '');            		// Trim - from end of text;
  }

  static keywords(text: string | string[]): string[] {

    if (Array.isArray(text)) {
      text = text.join(' ');
    }

    return AOString.trim(text.toString())
      .split(' ')
      .map(part => AOString.slug(part))
      .reduce((acc, val) => acc.concat([val].concat(val.split('-'))), [])
      .filter((value, index, self) => {
        return self.indexOf(value) === index;
      });
  }

}
